/**
 * @ngdoc directives
 * @memberof mercury.directives
 * @name icon-warning
 * @description Displays the Warning
 *  icon, this is pulled from the MUI icon we use in React.
 */
angular.module('mercury.directives.icon-warning', [])
.directive('iconWarning', function() {
    return {
      restrict: 'E',
      template: '<svg class="svg-icon-root" focusable="false" viewBox="0 0 24 24">' +
                  '<path d="M12 5.99 19.53 19H4.47zM12 2 1 21h22zm1 14h-2v2h2zm0-6h-2v4h2z"></path>' +
                '</svg>',
    }
  })